module.exports = __webpack_public_path__ + "static/media/back-ground3.186b3d3f.jpeg";